import type { ReactNode } from "react";
import {
  GREENFIELD_NAV_ITEMS,
  GREENFIELD_NAV_LABELS,
  type GreenfieldNavId,
  type GreenfieldView,
  navIdForView,
} from "../routing/greenfield-routing.js";

export function GreenfieldShell({
  view,
  query,
  onQuery,
  onNavigate,
  showFilter = false,
  children,
}: {
  readonly view: GreenfieldView;
  readonly query: string;
  readonly onQuery: (value: string) => void;
  readonly onNavigate: (nav: GreenfieldNavId) => void;
  readonly showFilter?: boolean;
  readonly children: ReactNode;
}) {
  const active = navIdForView(view);
  return (
    <div className="enrein-workspace-v1" data-greenfield-shell="true">
      <a className="ws-skip-link" href="#greenfield-main">
        Skip to content
      </a>
      <header
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 16,
          alignItems: "center",
          padding: "16px 24px",
          borderBottom: "1px solid var(--ws-border-subtle)",
          background: "var(--ws-surface-raised)",
        }}
      >
        <strong>Enrein Studio</strong>
        <nav aria-label="Studio">
          <ul style={{ display: "flex", gap: 8, listStyle: "none", padding: 0, margin: 0, flexWrap: "wrap" }}>
            {GREENFIELD_NAV_ITEMS.map((item) => (
              <li key={item}>
                <button
                  type="button"
                  className={active === item ? "ws-btn ws-btn-primary" : "ws-btn"}
                  aria-current={active === item ? "page" : undefined}
                  onClick={() => onNavigate(item)}
                >
                  {GREENFIELD_NAV_LABELS[item]}
                </button>
              </li>
            ))}
          </ul>
        </nav>
        {showFilter ? (
          <div className="ws-field" style={{ marginLeft: "auto", minWidth: 180 }}>
            <label htmlFor="greenfield-filter">Filter this list</label>
            <input
              id="greenfield-filter"
              value={query}
              onChange={(event) => onQuery(event.target.value)}
              placeholder="Filter loaded results"
            />
          </div>
        ) : null}
      </header>
      <main id="greenfield-main" style={{ padding: "24px", maxWidth: 1100, margin: "0 auto" }}>
        {children}
      </main>
    </div>
  );
}
